<template>
  <!-- 合同信息查看 -->
  <div class="wrap" style="overflow: hidden">
    <yd-navbar title="预约确认" fontsize="16px" style="font-weight: 800;font-family:PingFang SC;color:#000">
      <router-link to="/supplierIndex" slot="left">
        <yd-navbar-back-icon></yd-navbar-back-icon>
      </router-link>
    </yd-navbar>
    <yd-preview :buttons="btns">
      <yd-preview-header style="margin-top:10px">
        <div slot="left" style="color:#000">合同编号：{{contractInfo.contract.contract_no}}</div>
        <div slot="right">
          <yd-badge shape="square" v-if="contractInfo.contract.status=='3'" type="primary">可预约</yd-badge>
          <yd-badge shape="square" v-else-if="contractInfo.contract.status=='5'" type="success">已预约</yd-badge>
          <yd-badge shape="square" v-else-if="contractInfo.contract.status=='8'" type="warning">已用印</yd-badge>
        </div>
      </yd-preview-header>
<!--      <yd-preview-item>-->
<!--        <div slot="left">合同名称</div>-->
<!--        <div slot="right">{{contractInfo.contract.contract_name}}</div>-->
<!--      </yd-preview-item>-->
      <yd-preview-item>
        <div slot="left">供应商编码</div>
        <div slot="right">{{contractInfo.contract.supplier_no}}</div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left">供应商名称</div>
        <div slot="right">{{contractInfo.contract.supplier_name}}</div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left">报审序号</div>
        <div slot="right">{{contractInfo.contract.contract_no_area}}</div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left">签订时间</div>
        <div slot="right">{{contractInfo.contract.sign_date}}</div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left">备注</div>
        <div slot="right">{{contractInfo.contract.note}}</div>
      </yd-preview-item>
    </yd-preview>
    <yd-button size="large" type="primary" shape="circle" bgcolor="#2f6fff" color="#fff" @click.native="order">用印预约</yd-button>
    <el-dialog :visible.sync="dialogVisible" center fullscreen="true" show-close="false">
      <supplier-qr :orderQrCode="orderQrCode"></supplier-qr>
      <span slot="footer" class="dialog-footer">
        您已经成功预约<br>
        <el-link type="primary">{{orderSuccessDate}}</el-link>&nbsp;&nbsp;
        <el-link type="primary">{{orderSuccessPeriod}}</el-link><br>
        顺序号：<el-link size="large">{{orderSuccessNo}}</el-link><br>
        <el-button type="success" @click="handleClose">已预约成功，点击返回</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import axios from "axios";
import supplierQr from './supplier-qr.vue';
var baseUrl = process.env.API_ROOT;
export default {
  components: { supplierQr },
    data(){
        return {
            btns:[],
            dialogVisible: false,
            orderQrCode:'',
            orderSuccessDate:'',
            orderSuccessPeriod:'',
            orderSuccessPeriod:0,
            period : this.$route.query.period,
            contractInfo:{},
            userId:window.localStorage.getItem("checkUserId"),
            contractId:this.$route.query.contractId
        }
    },
    mounted(){
        this.getInfo(this.userId,this.contractId);
    },
    methods:{
        getInfo(userId,contractId){
            this.$dialog.loading.open('数据加载中');
            axios({
                method: "get",
                url: baseUrl + "detail?userId="+userId+"&contractId="+contractId
                }).then(resp => {
                if (resp.data.error_code == "0") {
                    console.log(resp.data)
                    this.contractInfo = resp.data
                }
                console.log(this.contractInfo)
                })
            this.$dialog.loading.close();
        },
        order(){
            this.$dialog.loading.open('预约中……');
              axios({
                method: "post",
                url: baseUrl + "apply",
                params:{
                 userId:this.userId,
                 contractId:this.contractId,
                 orderId:this.period.orderId||'',
                 orderListId:this.period.id||''
                }
                }).then(resp => {
                if (resp.data.result && resp.data.result ==="true") {
                    this.orderSuccessDate = resp.data.date
                    this.orderSuccessPeriod = resp.data.period
                    this.orderSuccessNo = resp.data.no
                    this.orderQrCode = resp.data.code
                    this.dialogVisible = true
                }else{
                    this.$dialog.toast({ mes: resp.data.message, timeout: 1500 });
                }
                })
            this.$dialog.loading.close();
        },
        handleClose(){
            this.$router.push({path:'/supplierIndex'});
            this.dialogVisible = false

        }
    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/supplier-order.vue